import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public iconBarVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  public toggleIconBar(): void {
    this.iconBarVisible.next(!this.iconBarVisible.value);
  }

}
